var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/promo-simple-banner.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if((lineno = 0, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"experience.reduced"]))) {
output += "\n\n    ";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality");
frame.set("imageQuality", t_1, true);
if(frame.topLevel) {
context.setVariable("imageQuality", t_1);
}
if(frame.topLevel) {
context.addExport("imageQuality", t_1);
}
output += "\n\n";
;
}
else {
output += "\n\n    ";
var t_2;
t_2 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"default_image_quality");
frame.set("imageQuality", t_2, true);
if(frame.topLevel) {
context.setVariable("imageQuality", t_2);
}
if(frame.topLevel) {
context.addExport("imageQuality", t_2);
}
output += "\n\n";
;
}
output += "\n\n";
var t_3;
t_3 = (lineno = 10, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["promo.linkAltText",""]));
frame.set("linkAltTextSafe", t_3, true);
if(frame.topLevel) {
context.setVariable("linkAltTextSafe", t_3);
}
if(frame.topLevel) {
context.addExport("linkAltTextSafe", t_3);
}
output += "\n\n<a ";
output += runtime.suppressValue((lineno = 12, colno = 6, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [runtime.contextOrFrameLookup(context, frame, "gaCategory"),runtime.contextOrFrameLookup(context, frame, "gaAction"),runtime.contextOrFrameLookup(context, frame, "linkAltTextSafe")])), env.opts.autoescape);
output += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"url")) {
output += "href=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"url"), env.opts.autoescape);
output += "\"";
;
}
output += " ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"externalLink")) {
output += "target=\"_blank\" rel=\"noopener noreferrer\" ";
;
}
output += " data-qa-simple-banner-tag>\n\n    <picture>\n        <source media=\"(min-width: 768px)\" srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"alternateBannerImage"), env.opts.autoescape);
output += "\">\n        <img class=\"c-";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "promoType"), env.opts.autoescape);
output += "-promo__image\" alt=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "linkAltTextSafe"), env.opts.autoescape);
output += "\" src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"bannerImage"), env.opts.autoescape);
if(runtime.contextOrFrameLookup(context, frame, "imageQuality")) {
output += "?q=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "imageQuality"), env.opts.autoescape);
;
}
output += "\" data-qa-simple-banner-img=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"bannerImage"), env.opts.autoescape);
output += "\"/>\n    </picture>\n\n</a>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/promo-simple-banner.j2"] , dependencies)